import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { ABOUT_URL, HERO_CTAS, type HeroCta } from '../content'
import communicationIllustration from '../assets/hero/communication.png?url'
import styles from './Hero.module.css'

// The two CTAs follow the Press hero: primary = solid black (ink), secondary = outlined black.
function ctaProps(variant: HeroCta['variant']): { color: 'black'; kind?: 'secondary' } {
  switch (variant) {
    case 'primary':
      return { color: 'black' }
    case 'secondary':
      return { color: 'black', kind: 'secondary' }
  }
}

export function Hero(): React.ReactElement {
  return (
    <section className={styles.hero}>
      <Container className={styles.hero__inner}>
        <div className={styles.hero__text}>
          <nav className={styles.hero__breadcrumb} aria-label="Fil d'Ariane">
            <a href={ABOUT_URL}>À propos</a>
            <span aria-hidden="true">›</span>
            <span className={styles.hero__breadcrumbTag}>Contact</span>
          </nav>
          <h1 className={styles.hero__title}>Contacter Ulule</h1>
          <p className={styles.hero__lede}>On est là pour vous aider !</p>
          <div className={styles.hero__actions}>
            {HERO_CTAS.map((cta) => (
              <plume.RoundButton key={cta.label} as="a" href={cta.href} size="big" {...ctaProps(cta.variant)}>
                {cta.label}
              </plume.RoundButton>
            ))}
          </div>
        </div>
        <div className={styles.hero__art}>
          <img className={styles.hero__image} src={communicationIllustration} alt="Contacter l'équipe Ulule" />
        </div>
      </Container>
    </section>
  )
}
